<div class="resend-dashboard">
  <h3>Acompanhamento de Edições e Reenvios</h3>
  <ng-container *ngIf="ready">
    <div class="filters">
      <form class="form-b4a" [formGroup]="form">
        <span class="p-float-label">
          <p-dropdown
            inputId="subscriptionId"
            [options]="subscriptions"
            (onChange)="changeSubscription()"
            formControlName="subscriptionId"
            [autoDisplayFirst]="false"
            appendTo="body"
          >
          </p-dropdown>
          <label for="subscriptionId">Assinatura</label>
        </span>
        <span class="p-float-label">
          <p-dropdown
            inputId="editionId"
            [options]="editions"
            *ngIf="editions"
            optionValue="editionId"
            optionLabel="theme"
            (onChange)="changeEdition()"
            [filter]="true"
            filterBy="theme,title,editionId,description"
            filterMatchMode="contains"
            [autoDisplayFirst]="false"
            formControlName="editionId"
            appendTo="body"
          >
            <ng-template pTemplate="item" let-edition>
              <ng-container *ngIf="form.value.subscriptionId">
                {{ edition.theme }}
                {{ editionDate(edition.editionId) }}
              </ng-container>
              <ng-container *ngIf="!form.value.subscriptionId">
                {{ editionDateName(edition.editionId) | titlecase }}
              </ng-container>
            </ng-template>
            <ng-template pTemplate="selectedItem">
              <ng-container *ngIf="form.value.subscriptionId">
                {{ edition?.theme }}
              </ng-container>
              <ng-container
                *ngIf="
                  edition && edition.editionId && !form.value.subscriptionId
                "
              >
                {{ editionDateName(edition.editionId) | titlecase }}
              </ng-container>
            </ng-template>
          </p-dropdown>
          <label for="editionId">Edição</label>
        </span>
      </form>
    </div>

    <!-- ==================== BLOCO EDIÇÃO ==================== -->
    <div class="section-group section-group--edition">
      <div class="section-group__header">
        <span>Edição</span>
      </div>

      <div class="section-panel">
        <h4>Status da Edição</h4>
        <div class="totals" *ngIf="editionStatusTotals">
          <div class="dashboard-card" (click)="findSubscribers(1000)">
            <span class="header header--success">
              Total assinantes
              <i class="pi pi-question-circle tooltip-icon"
                 [pTooltip]="editionStatusTooltip('Total assinantes')"
                 [escape]="false"
                 tooltipPosition="top"
                 (click)="$event.stopPropagation()"></i>
            </span>
            <span class="value">{{ totalSubscribers | number: '1.0-0' }}</span>
          </div>
          <div
            class="dashboard-card"
            (click)="findSubscribers(0, 'Aguardando alocação')"
          >
            <span class="header header--warning">
              Aguardando alocação
              <i class="pi pi-question-circle tooltip-icon"
                 [pTooltip]="editionStatusTooltip('Aguardando alocação')"
                 [escape]="false"
                 tooltipPosition="top"
                 (click)="$event.stopPropagation()"></i>
            </span>
            <span class="value">{{ pending | number: '1.0-0' }}</span>
          </div>
          <ng-container *ngFor="let total of subscriberEditionStatusList">
            <div
              class="dashboard-card"
              (click)="findSubscribers(total.id, total.status)"
            >
              <span
                class="header"
                [ngStyle]="{
                  'background': subscriberStatusColor(total.id),
                  color: 'white',
                  'text-align': 'center'
                }"
              >
                {{ total.status }}
                <i class="pi pi-question-circle tooltip-icon"
                   [pTooltip]="editionStatusTooltip(total.status)"
                   [escape]="false"
                   tooltipPosition="top"
                   (click)="$event.stopPropagation()"></i>
              </span>
              <span class="value">{{ total.total | number: '1.0-0' }}</span>
            </div>
            <div
              class="dashboard-card"
              *ngIf="total.status === 'Entregue' && alertCounts"
              (click)="findFailuresCombined()"
            >
              <span class="header header--danger">
                Ocorrências + Falhas
                <i class="pi pi-question-circle tooltip-icon"
                   pTooltip="Soma de Entregas com ocorrências + Entregas com falhas"
                   [escape]="false"
                   tooltipPosition="top"
                   (click)="$event.stopPropagation()"></i>
              </span>
              <span class="value">{{ falhaTotal | number: '1.0-0' }}</span>
            </div>
          </ng-container>
        </div>
        <div *ngIf="editionLoading && !editionStatusTotals" class="loading-section"><i class="pi pi-spin pi-spinner"></i> Carregando...</div>
      </div>

      <div class="section-panel">
        <h4>Alertas - Edição</h4>
        <div class="totals" *ngIf="alertCounts">
          <div
            class="dashboard-card"
            *ngFor="let sc of alertCounts.statusCounts"
            (click)="findAlertOrders(sc)"
          >
            <span class="header header--danger">
              {{ sc.statusName }}
              <i class="pi pi-question-circle tooltip-icon"
                 *ngIf="alertTooltips[sc.statusName]"
                 [pTooltip]="alertTooltips[sc.statusName]"
                 [escape]="false"
                 tooltipPosition="top"
                 (click)="$event.stopPropagation()"></i>
            </span>
            <span class="value">{{ sc.count | number: '1.0-0' }}</span>
          </div>
        </div>
        <div *ngIf="alertLoading && !alertCounts" class="loading-section"><i class="pi pi-spin pi-spinner"></i> Carregando...</div>
      </div>
    </div>

    <!-- ==================== BLOCO REENVIO ==================== -->
    <div class="section-group section-group--resend">
      <div class="section-group__header">
        <span>Reenvio</span>
      </div>

      <div class="section-panel">
        <h4>Status do Reenvio</h4>
        <div class="totals" *ngIf="resendCounts">
          <div
            class="dashboard-card"
            *ngFor="let sc of resendCounts.statusCounts"
            (click)="findResendOrders(sc)"
          >
            <span class="header header--indigo">
              {{ sc.statusName }}
              <i class="pi pi-question-circle tooltip-icon"
                 *ngIf="resendStatusTooltips[sc.statusName]"
                 [pTooltip]="resendStatusTooltips[sc.statusName]"
                 [escape]="false"
                 tooltipPosition="top"
                 (click)="$event.stopPropagation()"></i>
            </span>
            <span class="value">{{ sc.count | number: '1.0-0' }}</span>
          </div>
        </div>
        <div *ngIf="resendLoading && !resendCounts" class="loading-section"><i class="pi pi-spin pi-spinner"></i> Carregando...</div>
      </div>

      <div class="section-panel">
        <h4>Alertas - Reenvio</h4>
        <div class="totals" *ngIf="resendAlertCounts">
          <div
            class="dashboard-card"
            *ngFor="let sc of resendAlertCounts.statusCounts"
            (click)="findResendAlertOrders(sc)"
          >
            <span class="header header--danger">
              {{ sc.statusName }}
              <i class="pi pi-question-circle tooltip-icon"
                 *ngIf="alertTooltips[sc.statusName]"
                 [pTooltip]="alertTooltips[sc.statusName]"
                 [escape]="false"
                 tooltipPosition="top"
                 (click)="$event.stopPropagation()"></i>
            </span>
            <span class="value">{{ sc.count | number: '1.0-0' }}</span>
          </div>
        </div>
        <div *ngIf="resendAlertLoading && !resendAlertCounts" class="loading-section"><i class="pi pi-spin pi-spinner"></i> Carregando...</div>
      </div>
    </div>

  </ng-container>
</div>
